import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ScheduleTimeForm from '@wix/da-submit-shared/pkg/common/ScheduleTimeForm';
import { useController, useFormContext, useWatch } from 'react-hook-form';
import { DiscountFormField } from '../../../types';

interface Props {
  className?: string;
  isEditingExistingDiscount?: boolean;
}

const StartTimeInput: FC<Props> = ({ className, isEditingExistingDiscount }) => {
  const { t } = useTranslation();
  const { control, errors } = useFormContext();
  const error = errors[DiscountFormField.StartTimestamp];
  const {
    field: { onChange },
  } = useController({
    name: DiscountFormField.StartTimestamp,
    control,
    rules: {
      required: true,
    },
  });
  const startTimestamp = useWatch<number>({
    name: DiscountFormField.StartTimestamp,
    control,
  });

  const isInPast = !!startTimestamp && startTimestamp < Date.now() / 1000;
  const disabled = isEditingExistingDiscount && isInPast;

  return (
    <div>
      <ScheduleTimeForm
        initialTime={startTimestamp}
        fieldClassName={className}
        fieldGap={24}
        onChange={ts => ts && onChange(ts)}
        dateInputLabel={t('studio.discountModal.form.startTimeInput.date.label')}
        timeInputLabel={t('studio.discountModal.form.startTimeInput.time.label')}
        noBottomSpacing={false}
        errorMessage={error?.message}
        isRequired
        disabled={disabled}
        dropDirection="up"
      />
    </div>
  );
};
StartTimeInput.displayName = 'StartTimeInput';

export default StartTimeInput;
